import axios from "axios";

/**
 * Helper para obtener la configuración de axios con headers y baseURL.
 * @param token Token de autenticación.
 * @param urlAxioPP URL base de la API (opcional).
 * @returns Configuración para axios.
 */
export const getAxiosConfig = (token: string, urlAxioPP?: string) => {
  const url = urlAxioPP || localStorage.getItem("urlAxioPP") || "";
  return {
    baseURL: url,
    headers: { Authorization: `Bearer ${token}` },
  };
};
